import React, { useEffect, useMemo, useState } from "react";
import { Card, Col, Row, Typography, Alert, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";

const { Title, Text } = Typography;

function normalizePolicyPayload(res) {
  const payload = res?.data;
  const inner = payload?.data;
  if (Array.isArray(inner)) return inner[0] || null;
  if (inner && typeof inner === "object") return inner;
  if (payload && typeof payload === "object" && payload.type) return payload;
  return null;
}

const PublicPolicyView = ({ type = "PRIVACY" }) => {
  const { request } = useRequest();
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);
  const [error, setError] = useState("");

  const meta = useMemo(() => {
    const pageTitle =
      type === "TERMS" ? "Terms & Conditions" : "Privacy Policy";
    const docTitle = type === "TERMS" ? "TERMS & CONDITIONS" : "PRIVACY POLICY";
    return { pageTitle, docTitle };
  }, [type]);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError("");
    setPolicy(null);

    request({
      url: `${apiPath.listPolicies}`,
      method: "POST",
      data: { type: type, status: "PUBLISH" },
      onSuccess: (res) => {
        if (!mounted) return;
        const doc = normalizePolicyPayload(res);
        setPolicy(doc);
        setLoading(false);
      },
      onError: (err) => {
        if (!mounted) return;
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "Failed to load policy.";
        setError(msg);
        setLoading(false);
      },
    });

    return () => {
      mounted = false;
    };
  }, [type]);

  return (
    <div className="policy-public-page">
      <Row gutter={[24, 0]} justify="center">
        <Col span={24}>
          <Card
            bordered={false}
            className="policy-public-card"
            style={{ margin: "0 auto" }}
          >
            {loading ? (
              <div style={{ padding: 24, textAlign: "center" }}>
                <Spin />
              </div>
            ) : error ? (
              <Alert type="error" showIcon message={error} />
            ) : !policy ? (
              <Alert
                type="info"
                showIcon
                message="No published policy found."
              />
            ) : (
              <>
                <div className="policy-public-header">
                  <Text className="policy-public-kicker">{meta.pageTitle}</Text>
                  <Title level={1} className="policy-public-title">
                    {meta.docTitle}
                  </Title>

                  <div className="policy-public-meta">
                    {policy?.version && (
                      <span className="policy-meta-pill">
                        <span className="policy-meta-pill-label">Version</span>
                        <span className="policy-meta-pill-value">
                          {policy.version}
                        </span>
                      </span>
                    )}
                    {policy?.updatedAt && (
                      <span className="policy-meta-pill">
                        <span className="policy-meta-pill-label">
                          Last updated
                        </span>
                        <span className="policy-meta-pill-value">
                          {new Date(policy.updatedAt).toLocaleDateString()}
                        </span>
                      </span>
                    )}
                  </div>
                </div>

                {policy?.content ? (
                  <div
                    className="policy-content"
                    dangerouslySetInnerHTML={{ __html: policy.content }}
                  />
                ) : (
                  <Title level={5} style={{ margin: 0 }}>
                    No content available.
                  </Title>
                )}
              </>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PublicPolicyView;
